import styled from 'styled-components';

import colors from '../../../../styles/colors';
import { ReactComponent as AttachmentIcon } from '../../../../assets/icons/attachment-icon.svg';

const FileUploadButtonContainer = styled.div`
  input {
    display: none;
  }
`;

const FileAttachmentIcon = styled(AttachmentIcon)`
  cursor: pointer;
  display: flex;
  height: 22px;
  width: 20px;
  > path {
    fill: ${colors.base.alpha};
  }
`;

export {
  FileUploadButtonContainer,
  FileAttachmentIcon,
};
